import CouponsTable from "./CouponsTable";

export default CouponsTable;